/**
 * 画像確認画面起動用VOクラス
 *
 * @export KYMW1600InputModel
 * @class KYMW1600InputModel
 */
export class KYMW1600InputModel {
  /** 画面ＩＤ */
  public screenId: string = <string>'';
  /** Ｐコード */
  public pcode: string = <string>'';

}

